var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOliverIconBaseBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.581 1.44775H5.97144V7.05728H11.581V1.44775Z",
    fill: "#3D4C66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60953 1.44775C2.705 1.66115 0.387503 4.05546 0.180954 7.05728H5.60953V1.44775Z",
    fill: "#3D4C66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60953 7.41895H0.180954V13.0285H5.60953V7.41895Z",
    fill: "#3D4C66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5524 7.41895H11.9429V13.0285H17.5524V7.41895Z",
    fill: "#3D4C66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9429 18.8192C14.9452 18.6136 17.3389 16.2961 17.5524 13.3906H11.9429V18.8192Z",
    fill: "#3D4C66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.581 13.3906H5.97144V18.8192H11.581V13.3906Z",
    fill: "#3D4C66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60953 13.3906H0.180954C0.386514 16.2971 2.70302 18.6136 5.60953 18.8192V13.3906Z",
    fill: "#3D4C66"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8476 0.181152V5.97163H18.6381C18.6371 2.77366 16.0446 0.181152 12.8476 0.181152Z",
    fill: "#3D4C66"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOliverIconBaseBlue);
export default __webpack_public_path__ + "static/media/Oliver-Icon-BaseBlue.4aae3d22e7628b01b00cd9c6c476bbe3.svg";
export { ForwardRef as ReactComponent };